export const API_ENDPOINT_TESTNET = 'https://api-test.iexchange.global';
export const API_ENDPOINT_MAINNET = 'https://api.iexchange.global';
export const API_ENDPOINT_DEV = 'http://localhost:9009';
// export const API_ENDPOINT_DEV = 'http://192.168.8.123:9009';
export const API_ENDPOINT_STAGING = 'https://api-staging.iexchange.global';

export const SOCKET_APP_KEY_MAINNET = 'iexchangeP2P-Mainnet';
export const SOCKET_APP_KEY_TESTNET = 'iexchange-w';

export const SOCKET_HOST_MAINNET = 'wss.iexchange.global';
export const SOCKET_HOST_TESTNET = 'wss-test.iexchange.global';
export const SOCKET_HOST_STAGING = 'wss-test.iexchange.global';
export const SOCKET_HOST_DEV = '127.0.0.1';

export const IS_SPONSORSHIP_ENABLED = true;

export const SOCKET_PORT_DEV = 6002;

export const BASE_URL_MAINNET = 'https://app.exchange.global';
export const BASE_URL_DEV = 'http://localhost:3000';
export const BASE_URL_STAGING = 'https://staging.exchange.tech';
